const openRegulationModal = document.getElementById('open-regulation-modal');
const closeRegulationModal = document.getElementById('close-regulation-modal');
const closeRegulationModal2 = document.getElementById('close-regulation-modal-2');
const modalOverlay = document.getElementById('modal-overlay');
const regulationModal = document.getElementById('regulation-modal');

const descriptionText = document.querySelector('.event-details__text');
const readMoreContainer = document.querySelector('.event-details__read-more');
const readMore = document.querySelector('.event-details__read-more #read-more');
const readLess = document.querySelector('.event-details__read-more #read-less');

const maxHeight = 500;

function closeModal() {
  modalOverlay.style.display = 'none';
  regulationModal.style.display = 'none';
  document.body.style.overflow = 'auto';
}

function toggleDescription(expand) {
  descriptionText.classList.toggle('text-expanded', expand);
  readMore.style.display = expand ? 'none' : 'block';
  readLess.style.display = expand ? 'block' : 'none';
}

document.addEventListener('DOMContentLoaded', () => {
  if (descriptionText.scrollHeight > maxHeight) {
    readMoreContainer.style.display = 'block';
  }

  if (openRegulationModal && regulationModal) {
    openRegulationModal.addEventListener('click', e => {
      e.preventDefault();
      modalOverlay.style.display = 'block';
      regulationModal.style.display = 'block';
      document.body.style.overflow = 'hidden';
    });

    closeRegulationModal.addEventListener('click', closeModal);
    closeRegulationModal2.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', closeModal);
  }

  readMore.addEventListener('click', () => toggleDescription(true));
  readLess.addEventListener('click', () => toggleDescription(false));
});

// Addiciona _blank para todos os links dentro do texto de detalhes de evento
document.addEventListener('DOMContentLoaded', () => {
  const eventDetailsElements = document.querySelectorAll('.event-details__text');

  eventDetailsElements.forEach(element => {
    const links = element.getElementsByTagName('a');

    Array.from(links).forEach(link => {
      link.setAttribute('target', '_blank');
    });
  });
});
